module.exports = __webpack_public_path__ + "img/content-with-img-links-ford.c38b846e.jpg";